import axios from "axios"

// 共通ヘッダの定義などを行う
const token = document.querySelector<HTMLMetaElement>("meta[name='csrf-token']")?.content
if (token) {
  axios.defaults.headers.common["X-CSRF-TOKEN"] = token
}
axios.defaults.headers.common["Accept"] = "application/json"

export default axios

// APIに関する定数
export const HTTP_STATUS_NO_CONTENT = 204
export const HTTP_STATUS_UNPROCESSABLE_ENTITY = 422
